module Visonum.BulkPingApp.DetailsPanel
  ( view
  ) where

import Visonum.BulkPingApp.Prelude

import Data.BasicURL as BaseURL
import Data.Either (Either(..))
import Data.Map as Map
import Data.Maybe (Maybe(..), fromMaybe)
import Data.Newtype (unwrap)
import Data.Time.Duration (Milliseconds)
import Data.Time.Duration as DTD
import Halogen.HTML.Elements as H
import Visonum.BulkPingApp.Components.App.Types (Action(..), DownloadFormat(..), State)
import Visonum.BulkPingApp.Views.PrimaryButton as PrimaryButton

view :: forall w. State -> AppHTML w Action
view state =
  let
    elRoot = styleNode H.div
      "DetailsPanel"
      [ inline
          { display: "flex"
          , flexDirection: "column"
          , width: "100%"
          , justifyContent: "end"
          , alignItems: "center"
          , padding: "15px"
          , gap: "30px"
          }
      ]

    elResults = styleNode H.div
      "DetailsPanelResults"
      [ inline
          { display: "flex"
          , flexDirection: "column"
          , width: "100%"
          , justifyContent: "end"
          , alignItems: "center"
          , gap: "15px"
          }
      ]

    elBottomBar = styleNode H.div
      "DetailsPanelBottomBar"
      [ inline
          { display: "flex"
          , flexDirection: "row"
          , width: "100%"
          , justifyContent: "center"
          , alignItems: "center"
          , gap: "15px"
          }
      ]

    elLine = styleNode H.div
      "DetailsPanelLine"
      [ inline
          { width: "100%"
          , height: "1px"
          , backgroundColor: "#e0e0e0"
          }
      ]

    elJobId = styleNode H.div
      "DetailsPanelJobId"
      [ inline
          { fontSize: "12px"
          , fontWeight: "bold"
          , fontFamily: "Arial"
          }
      ]

  in
    elRoot
      []
      [ case state.details of
          Just { jobId, result: Just (Right { config }) } ->
            elResults []
              [ viewData
                  [ [ { key: "Job ID"
                      , value: elJobId [] [ text jobId ]
                      }
                    ]
                  , [ { key: "Status"
                      , value: (Map.lookup jobId state.bulkPingStatus.jobs)
                          # map (\r -> show r.status)
                          # fromMaybe "N/A"
                          # text
                      }
                    , { key: "Number of Errors"
                      , value: (Map.lookup jobId state.bulkPingStatus.jobs)
                          # map (\r -> show r.errorsCount)
                          # fromMaybe "N/A"
                          # text
                      }
                    ]
                  ]
              , elLine [] []
              , viewData $ map pure
                  [ { key: "Agent URL"
                    , value: text $ BaseURL.print config.agentUrl
                    }
                  , { key: "Ping Count per IP"
                    , value: text $ show config.pingCountPerIp
                    }
                  , { key: "Interval Between Pings (ms)"
                    , value: text $ show $ unwrap (DTD.fromDuration config.intervalBetweenPingsMillis :: Milliseconds)
                    }
                  , { key: "Interval Between IPs (ms)"
                    , value: text $ show $ unwrap (DTD.fromDuration config.intervalBetweenIpsMillis :: Milliseconds)
                    }
                  , { key: "Use TCP SYN to Port"
                    , value: text $ case config.useSynToPort of
                        Just val -> show val
                        Nothing -> "false"
                    }
                  , { key: "Use ICMP"
                    , value: text $ show config.useIcmp
                    }
                  ]
              , elBottomBar []
                  [ PrimaryButton.view
                      { label: "Download JSON"
                      , onClick: DownloadResults jobId DownloadJson
                      , disabled: false
                      }
                  , PrimaryButton.view
                      { label: "Download CSV"
                      , onClick: DownloadResults jobId DownloadCsv
                      , disabled: false
                      }
                  ]
              ]
          _ -> text ""
      ]

viewData :: forall w. Array (Array { key :: String, value :: AppHTML w Action }) -> AppHTML w Action
viewData data_ =
  let
    elRoot = styleNode H.div
      "DetailsPanel"
      [ inline
          { display: "flex"
          , flexDirection: "column"
          , width: "100%"
          , justifyContent: "end"
          , alignItems: "center"
          , gap: "15px"
          }
      ]

    elRow = styleNode H.div
      "DetailsPanelRow"
      [ inline
          { display: "flex"
          , flexDirection: "row"
          , width: "100%"
          , justifyContent: "space-between"
          , alignItems: "center"
          , gap: "10px"
          }
      ]

    elItem = styleNode H.div
      "DetailsPanelItem"
      [ inline
          { display: "flex"
          , flexDirection: "column"
          , width: "100%"
          , gap: "5px"
          , backgroundColor: "#f0f0f0"
          , border: "1px solid #e0e0e0"
          , borderRadius: "5px"
          , padding: "5px"
          }
      ]

    elKey = styleNode H.div
      "DetailsPanelKey"
      [ inline
          { fontSize: "12px"
          , fontWeight: "bold"
          , fontFamily: "Arial"
          }
      ]

    elValue = styleNode H.div
      "DetailsPanelValue"
      [ inline
          { fontSize: "10px"
          , fontFamily: "Arial"
          }
      ]
  in
    elRoot
      []
      ( map
          ( \row ->
              elRow
                []
                ( map
                    ( \item ->
                        elItem
                          []
                          [ elKey [] [ text item.key ]
                          , elValue [] [ item.value ]
                          ]
                    )
                    row
                )
          )
          data_
      )
